import React, { Component } from "react";
import styles from "./reportContructor.module.scss";
import { withReportsList } from "../../../shared/containers/containerReportsList";
import { withCustomReport } from "../../../shared/containers/containerCustomReport";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SkipPreviousIcon from "@mui/icons-material/SkipPrevious";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import { Input, TextField } from "@mui/material";

class ReportFieldParametrConstructor extends Component {
  constructor(props) {
    super(props);
  }

  onDelete() {
    const { onDeleteCustomReportField, selectedCustomReportId, field } = this.props;
    onDeleteCustomReportField({ id: field.id }, selectedCustomReportId);
  }

  onChangeTitle(title) {
    const { onChangeTitleHahdle } = this.props;

    onChangeTitleHahdle(title);
  }

  onChangeCss(value) {
    const { onChangeCssHahdle } = this.props;

    onChangeCssHahdle(value);
  }

  onChangeExcel(value) {
    const { onChangeExcelHahdle } = this.props;

    onChangeExcelHahdle(value);
  }

  onShift(value) {
    const { onShiftHandle, field } = this.props;
    onShiftHandle(field, field.number + value);
  }

  render() {
    const { field, countFixFields } = this.props;

    const isFix = field.number <= countFixFields;

    return (
      <div>
        <div className={styles.fieldParametrsContainer}>
          {!isFix ? (
            <TooltipWrapper title={`Сменить порядок`} position="top">
              <SkipPreviousIcon
                fontSize="small"
                onClick={(e) => {
                  if (field.number > countFixFields + 1) {
                    e.stopPropagation();
                    this.onShift(-1);
                  }
                }}
              />
            </TooltipWrapper>
          ) : null}

          <div className={styles.fieldItemTitle}>
            <Input
              fontSize="small"
              name="dashboardTitle"
              type="text"
              onChange={(e) => {
                this.onChangeTitle(e.target.value);
              }}
              defaultValue={field.dashboard.title}
              fullWidth={false}
              style={{ fontSize: "11px", width: "85%" }}
            />
            {field.dashboard.measure}
          </div>

          <div className={styles.dashboardsItemRightContainer}>
            {!isFix ? (
              <TooltipWrapper title={`Сменить порядок `} position="top">
                <SkipNextIcon
                  fontSize="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.onShift(1);
                  }}
                />
              </TooltipWrapper>
            ) : null}

            {!isFix ? (
              <TooltipWrapper title={`Удалить ${field.dashboard.title}`} position="top">
                <DeleteOutlineIcon
                  fontSize="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.onDelete();
                  }}
                />
              </TooltipWrapper>
            ) : null}
          </div>
        </div>

        <div className={styles.fieldWidthImputContainer}>
          <TextField
            id="outlined-basic"
            label="Ширина колонки на вэб странице (px)"
            variant="outlined"
            size="small"
            type="number"
            InputProps={{ inputProps: { min: 40, max: 450 } }}
            value={field.cssColumnWidth}
            onChange={(e) => {
              this.onChangeCss(e.target.value);
            }}
            style={{ width: "250px" }}
          />
        </div>

        <div className={styles.fieldWidthImputContainer}>
          <TextField
            id="outlined-basic"
            label={`Ширина колонки в "Excel"`}
            variant="outlined"
            size="small"
            type="number"
            InputProps={{ inputProps: { min: 10, max: 100 } }}
            value={field.excelColumnWidth}
            onChange={(e) => {
              this.onChangeExcel(e.target.value);
            }}
            style={{ width: "250px" }}
          />
        </div>
      </div>
    );
  }
}

export default withCustomReport(withReportsList(React.memo(ReportFieldParametrConstructor)));
